export default __webpack_public_path__ + "static/media/github.4cd3a2bc.svg";